import { RootState } from '../redux';

export const selectUserId = (state: RootState) => state.user.id;

export const selectRole = (state: RootState) => state.user.role;

export const selectUserFirm = (state: RootState) => state.user.firm;

export const selectUserFirstName = (state: RootState) => state.user.firstName;
